module.exports = __webpack_public_path__ + "icon-right/icon-right-2cfdaaf5cbfe6996c10a7ef27083ef87.svg";